export const ACTIONS_COUNT = 7
